import { FeedItem } from '@knocklabs/client'
import { Routes } from '@scalis/routes'
import { NotificationEventName } from '~/domain/enums/enum.schema'
import ExtendedLogo from '~/public/images/SCALIS_LOGO_BLUE.svg'
import CircleLogo from '~/public/images/scalis-compact-logo.svg'

const CIRCLE_LOGO_WIDTH = 36
const CIRCLE_LOGO_HEIGHT = 36
const EXTENDED_LOGO_WIDTH = 96
const EXTENDED_LOGO_HEIGHT = 20

export const getCompanyLogoProps = (isExtendedLogo: boolean) => {
  if (isExtendedLogo) {
    const src = ExtendedLogo ?? ''
    const width = EXTENDED_LOGO_WIDTH
    const height = EXTENDED_LOGO_HEIGHT
    return {
      src,
      width,
      height,
    }
  }
  const src = CircleLogo ?? ''
  const width = CIRCLE_LOGO_WIDTH
  const height = CIRCLE_LOGO_HEIGHT
  return {
    src,
    width,
    height,
  }
}

export const shouldRenderSearchMenu = (isSignedIn: boolean, pathname: string | null, breakpoint: boolean) => {
  return isSignedIn && pathname !== Routes.jobs_view && !pathname?.includes('/job') && breakpoint
}

export const getNotificationLink = (notification: FeedItem) => {
  switch (notification.data?.notificationName) {
    case NotificationEventName.CANDIDATE_HIRED_ON_MY_JOB:
      return Routes.job_listing.view({ requisitionId: notification.data?.requisitionId })
    case NotificationEventName.NEW_CANDIDATE_MESSAGE_RECEIVED:
      return Routes.company.messaging
    case NotificationEventName.OFFER_SENT_TO_CANDIDATE:
      return Routes.company.candidate({ candidateProfileId: notification.data?.candidateId })
    case NotificationEventName.CANDIDATE_SIGNED_OFFER:
      return Routes.company.candidate({ candidateProfileId: notification.data?.candidateId })
    case NotificationEventName.REFERRAL_SUBMITTED_FOR_MY_JOB:
      return Routes.company.candidate({ candidateProfileId: notification.data?.candidateId })
    case NotificationEventName.SCORECARD_ASSIGNED_TO_ME:
      return Routes.company.candidate({ candidateProfileId: notification.data?.candidateId })
    case NotificationEventName.INTERVIEW_SELF_SCHEDULED_WITH_ME:
      return Routes.company.candidate({ candidateProfileId: notification.data?.candidateId })
    case NotificationEventName.ASSIGNED_AS_INTERVIEWER:
      return Routes.company.candidate({ candidateProfileId: notification.data?.candidateId })
    case NotificationEventName.INTERVIEW_TEAM_SCORECARD_SUBMITTED:
      return Routes.company.candidate({ candidateProfileId: notification.data?.candidateId })
    case NotificationEventName.INTERVIEW_DAY_MORNING_REMINDER:
      return Routes.company.candidate({ candidateProfileId: notification.data?.candidateId })
    case NotificationEventName.NEW_APPLICANT_TO_MY_JOB:
      return Routes.job_listing.stage({
        requisitionId: notification.data?.requisitionId,
        milestoneId: notification.data?.milestoneId,
        stageId: notification.data?.stageId,
      })
    case NotificationEventName.JOB_AD_CAMPAIGN_EXPIRING_SOON:
      return Routes.job_listing.view_job_campaigns({
        requisitionId: notification.data?.requisitionId,
      })
    case NotificationEventName.JOB_CLOSED_THAT_I_WAS_ASSIGNED_TO:
      return Routes.job_listing.view({
        requisitionId: notification.data?.requisitionId,
      })
    case NotificationEventName.NEW_CANDIDATE_MATCH_FOR_MY_JOB:
      return Routes.job_listing.pipeline({
        requisitionId: notification.data?.requisitionId,
      })
    case NotificationEventName.ASSIGNED_TO_HIRING_TEAM:
      return Routes.job_listing.view({
        requisitionId: notification.data?.requisitionId,
      })
    case NotificationEventName.ASSIGNED_AS_RECRUITER:
      return Routes.job_listing.view_active_candidates({
        requisitionId: notification.data?.requisitionId,
      })
    case NotificationEventName.ASSIGNED_AS_HIRING_MANAGER:
      return Routes.job_listing.view_active_candidates({
        requisitionId: notification.data?.requisitionId,
      })
    default:
      return ''
  }
}
